import { AuthService } from '../providers/auth-service';
import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, Events, AlertController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Http } from '@angular/http';
import { SocialSharing } from '@ionic-native/social-sharing';

import { HomePage } from '../pages/home/home';
import { VerMapaPage } from '../pages/vermapa/vermapa';
import { LoginPage } from '../pages/login/login';
import { SobrePage } from '../pages/sobre/sobre';
import { TermosPage } from '../pages/termos/termos';
import { SobreNosPage } from '../pages/sobrenos/sobrenos';
import { AjudaPage } from '../pages/ajuda/ajuda';
import { PoliticaPage } from '../pages/politica/politica';
import { OcorrenciasPage } from '../pages/ocorrencias/ocorrencias';
import { AddOcorrenciaPage } from '../pages/ocorrencias/addocorrencia';
import { AddDadosPage } from '../pages/dados/adddados';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {

  @ViewChild(Nav) nav;
 
  rootPage:any = HomePage;

  public nome:any;
  public email:any;

  public verMapaPage = VerMapaPage;
  public loginPage = LoginPage;
  public sobrePage = SobrePage;
  public termosPage = TermosPage;
  public sobreNosPage = SobreNosPage;
  public ajudaPage = AjudaPage;
  public politicaPage = PoliticaPage;
  public ocorrenciasPage = OcorrenciasPage;
  public addOcorrenciaPage = AddOcorrenciaPage;
  public addDadosPage = AddDadosPage;

  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen, private auth: AuthService, 
              public events: Events, private http: Http, private alertCtrl: AlertController, private socialSharing: SocialSharing) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();
    });

    if(localStorage.getItem("idUsuario")){
      this.nome = localStorage.getItem("nomeUsuario");
      this.email = localStorage.getItem("emailUsuario");
    }

    this.events.subscribe('user:created', (nome, email) => {
      // user and time are the same arguments passed in `events.publish(user, time)`
      localStorage.setItem("nomeUsuario", nome);
      localStorage.setItem("emailUsuario", email);

      this.nome = nome;
      this.email = email;
    });
  }

  openPage(page){
    this.nav.setRoot(page);
  }

  abreDados(){
    var div = document.getElementById("dados");
    div.style.height = div.style.height === '0px' ? '140px' : '0px';
  }

  share() {
    this.socialSharing.share('Compartilhe para uma cidade com mais saúde', 'Mais Alguém Doente?', 'www/assets/img/MAD.png');
  }

  alteraDados(campo){
    var nome = (<HTMLInputElement>document.getElementById('campo-nome')).value;
    var senha = (<HTMLInputElement>document.getElementById('campo-senha')).value;
    var email = (<HTMLInputElement>document.getElementById('campo-email')).value;

    var strNome = "";
    var strSenha = "";
    var strEmail = "";

    var msg = campo+" alterado com sucesso!";

    if(campo === "Nome"){
      strNome = "&nome="+nome;
      localStorage.setItem("nomeUsuario", nome);
    }
    else if(campo === "Email"){
      strEmail = "&email="+email;
      localStorage.setItem("emailUsuario", email);
    }
    else if(campo === "Senha" && senha != ""){
      strSenha = "&senha="+senha;
      msg = "Senha alterada com sucesso!";
    } else{
      msg = "Prencha o campo senha!";
    }

    let url = "http://maisalguemdoente.com.br/usuariosApp/usuarios/webService/updateUsuario?id="+localStorage.getItem("idUsuario")+strNome+strSenha+strEmail;
   
    this.http.get(url).map(res => res.json()).subscribe(data => {
     let alert = this.alertCtrl.create({
         subTitle: msg,
            buttons: ['OK']
          });
       alert.present();
    });
  }


  logout(){
    this.auth.logout().subscribe(allowed => {
       if (allowed) {        
         this.nav.push(HomePage);
       } else {
             console.log("Por favor, tente novamente.");
      }
    },
     error => {
        console.log(error);
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts